import helpers from './helpers'
import services from './services'

export default {
  helpers,
  services
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/index.js